import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-abteilung-list-view',
  imports: [],
  templateUrl: './abteilung.list-view.html',
  styleUrls: ['./abteilung.list-view.css'],
})
export class AbteilungListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
